import { render } from "./App.vue?vue&type=template&id=b5d327d0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b5d327d0&lang=css"

import exportComponent from "C:\\Users\\Dell\\latam\\latamlogistichn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__